import { render, staticRenderFns } from "./myFeedback.vue?vue&type=template&id=2fc912c2&scoped=true"
import script from "./myFeedback.vue?vue&type=script&lang=js"
export * from "./myFeedback.vue?vue&type=script&lang=js"
import style0 from "./myFeedback.vue?vue&type=style&index=0&id=2fc912c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc912c2",
  null
  
)

export default component.exports